"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.toyotaLabels = void 0;
var types = __importStar(require("../labelTypes"));
exports.toyotaLabels = (_a = {},
    _a[types.DealSummaryLabelType.MSRP] = 'Total Suggested Retail Price',
    _a[types.DealSummaryLabelType.MSRP_SHORT] = 'TSRP',
    _a[types.DealSummaryLabelType.MSRP_INFO] = 'Total Suggested Retail Price includes manufacturer and distributor options and delivery, process and handling fees, which may be subject to change at any time. Excludes taxes, title, license and dealer options, fees and charges. Dealer price will vary.',
    _a);
